import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { upsellContentStyles } from './styles/upsell-content.styles';
import type { UpsellContentPropsInterface } from './types/upsell-content.types';

/**
 * @since 10.0.0
 */
export const UpsellContent = forwardRef<HTMLDivElement, UpsellContentPropsInterface>(
  (props: UpsellContentPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const styles = css(upsellContentStyles, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Upsell.Content"
        className={cx('c11n', 'c11n_upsell__content', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

UpsellContent.displayName = 'Upsell.Content';
